<template>
  <el-skeleton :loading="loading" :rows="6">
    <template #template>
      <div
        v-for="i in 10"
        :key="i"
        class="flex bg-white px-4 py-5 siblings:mt-1"
      >
        <el-skeleton-item class="w-60 h-34 bg-gray-50" variant="image" />
        <div class="ml-4 flex-1">
          <el-skeleton-item
            class="w-1/2 mb-3 bg-info bg-opacity-20"
            variant="h1"
          />
          <el-skeleton-item class="mb-2" variant="p" />
          <div class="flex">
            <el-skeleton-item
              v-for="i in 3"
              :key="i"
              class="w-30 siblings:ml-2 h-6 bg-warn bg-opacity-20"
              variant="rect"
            />
          </div>
          <div class="flex justify-end mt-5">
            <el-skeleton-item
              v-for="i in 3"
              :key="i"
              class="w-30 siblings:ml-2 last:bg-primary last:bg-opacity-30"
              variant="button"
            />
          </div>
        </div>
      </div>
    </template>
    <slot />
    <!-- <ul>
      <transition-group enter-active-class="animate__animated animate__fadeIn">
        
      </transition-group>
    </ul> -->
  </el-skeleton>
</template>

<script>
export default {
  name: "ListProductSkeleton",
  props: {
    loading: Boolean,
    products: {
      type: Array,
      default: () => []
    }
  }
};
</script>
